<div class="settings">
  <h1 class="title">{{ content?.fields.title }}</h1>

  <app-settings-your-information
    [content]="content"
  ></app-settings-your-information>

  <app-default-payment-method
    *ngIf="subscriptions$ | async as subscriptions"
    [content]="content"
  ></app-default-payment-method>

  <div class="settings-box" *ngIf="subscriptions$ | async as subscriptions">
    <div class="settings-box__header">
      <h2 class="settings-box__title">
        {{
          content?.fields?.resources | findResource: 'settings.yourOrderTitle'
        }}
      </h2>
    </div>
    <div class="subscriptions">
      <ng-container *ngFor="let subscription of subscriptions">
        <app-settings-subscription
          [content]="content"
          [subscriptionId]="subscription.id"
          [globalContent]="globalContent$ | async"
        >
        </app-settings-subscription>
      </ng-container>
    </div>
    <div
      class="subscriptions__no-subscriptions"
      *ngIf="subscriptions.length === 0"
    >
      {{
        content?.fields?.resources
          | findResource: 'settings.noActiveSubscriptionsNotice'
      }}
    </div>
  </div>

  <div class="invoices settings-box" *ngIf="invoices$ | async as invoices">
    <div class="settings-box__header">
      <h2 class="settings-box__title">
        {{ content?.fields?.resources | findResource: 'settings.invoiceTitle' }}
      </h2>
    </div>

    <div class="invoices">
      <div class="invoice" *ngFor="let invoice of invoices">
        <div *ngIf="false">{{ invoice | json }}</div>
        <div class="invoice__column">
          {{ invoice.created * 1000 | date: 'd.M.y' }}
        </div>
        <div class="invoice__column">
          <span *ngIf="invoice.status === 'open'">{{
            invoice.amount_due / 100
              | currency
                : (invoice.currency | uppercase)
                : 'symbol-narrow'
                : '1.2-2'
                : 'fi'
          }}</span>
          <span *ngIf="invoice.status === 'paid'">{{
            invoice.amount_paid / 100
              | currency
                : (invoice.currency | uppercase)
                : 'symbol-narrow'
                : '1.2-2'
                : 'fi'
          }}</span>
          <span *ngIf="invoice.status === 'void'">{{
            invoice.amount_remaining / 100
              | currency
                : (invoice.currency | uppercase)
                : 'symbol-narrow'
                : '1.2-2'
                : 'fi'
          }}</span>
          <span *ngIf="invoice.status === 'uncollectible'">{{
            invoice.amount_remaining / 100
              | currency
                : (invoice.currency | uppercase)
                : 'symbol-narrow'
                : '1.2-2'
                : 'fi'
          }}</span>
        </div>
        <div class="invoice__column">
          <span *ngIf="invoice.status === 'open'">{{
            content?.fields?.resources | findResource: 'settings.open'
          }}</span>
          <span *ngIf="invoice.status === 'void'">{{
            content?.fields?.resources | findResource: 'settings.void'
          }}</span>
          <span *ngIf="invoice.status === 'paid'">{{
            content?.fields?.resources | findResource: 'settings.paid'
          }}</span>
          <span *ngIf="invoice.status === 'uncollectible'">{{
            content?.fields?.resources | findResource: 'settings.uncollectible'
          }}</span>
        </div>
        <div class="invoice__column invoice__column--link-container">
          <a
            class="invoice__link"
            *ngIf="invoice.status === 'open'"
            [href]="invoice.hosted_invoice_url"
            target="_blank"
            >{{
              content?.fields?.resources
                | findResource: 'settings.finalizePayment'
            }}</a
          >
          <ng-container
            *ngIf="
              invoice.payment_intent?.charges?.data[0]?.receipt_url !== null
            "
          >
            <a
              class="invoice__link"
              *ngIf="
                invoice.status === 'paid' ||
                invoice.status === 'void' ||
                invoice.status === 'uncollectible'
              "
              [href]="invoice.payment_intent?.charges?.data[0]?.receipt_url"
              target="_blank"
            >
              {{
                content?.fields?.resources
                  | findResource: 'settings.receiptLinkText'
              }}
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <app-settings-communication [content]="content"></app-settings-communication>
</div>
